module.exports = __webpack_public_path__ + "static/fonts/Mont-ThinItalic.1c6dd4b.ttf";